<template>
  <div class="perf-chart-main-symbol-input-container">
    <label
      for="perf-chart-main-symbol-input"
      class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
    >MAIN CHART SYMBOL</label>
    <br />
    <input
      type="text"
      placeholder="Enter a Symbol"
      class="sc3-text-input sc3-text-input-inline sc3-text-input-compact sc3-text-input-grey-and-black"
      id="perf-chart-main-symbol-input"
      v-model="symbol"
      ref="symbolInputElement"
      @keydown.enter="handleEnterKeyDownSymbolInput()"
      @blur="handleBlurSymbolInput()"
      autocomplete="off"
    />
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useChartStore } from '@/stores/chartStore';
  import { useChartNotesV2 } from '@/composables/useChartNotesV2';
  import { usePerfChartSymbols } from '@/composables/usePerfChartSymbols';
  import { CHART_TYPE_OPTION_PERF_CHART } from '@/enums/chart-type-options';

  const chartStore = useChartStore();
  const { symbol: chartStoreSymbol } = storeToRefs(chartStore);
  const {
    isActivatingAnnotationMode,
    isAnnotating
  } = useChartNotesV2();
  const {
    MAXIMUM_NUMBER_OF_PERF_CHART_SYMBOLS,
    getPerfChartSymbols
  } = usePerfChartSymbols();

  const symbol = ref(chartStoreSymbol.value);
  const symbolInputElement = ref<HTMLInputElement>();

  function handleEnterKeyDownSymbolInput() {
    symbolInputElement.value?.blur();
  }

  async function handleBlurSymbolInput() {
    let perfChartSymbols = getPerfChartSymbols(symbol.value).slice(0, MAXIMUM_NUMBER_OF_PERF_CHART_SYMBOLS);
    const mainChartSymbol = perfChartSymbols.at(0)?.symbol ?? '';
    perfChartSymbols = perfChartSymbols.slice(1);

    if (
      !mainChartSymbol ||
      isActivatingAnnotationMode.value ||
      isAnnotating.value
    ) {
      syncMainChartSymbol();
      return;
    }

    if (perfChartSymbols.length) {
      chartStore.$patch({
        symbol: mainChartSymbol,
        chartType: CHART_TYPE_OPTION_PERF_CHART.value,
        perfChartSymbols,
        latestLoadPerfChartTimeStamp: Date.now()
      });
    } else {
      chartStore.$patch({ symbol: mainChartSymbol });
    }

    symbol.value = mainChartSymbol;
  }

  function syncMainChartSymbol() {
    symbol.value = chartStoreSymbol.value;
  }

  watch(chartStoreSymbol, syncMainChartSymbol);
</script>

<style scoped>
  .perf-chart-main-symbol-input-container {
    margin-left: 22px;
  }
</style>
